export default __webpack_public_path__ + "static/media/T660_CoC.1ec22390.pdf";